/**
 * 格式验证
 */
import validator from '@mx/vix/validator';

interface IBindCardMap {
  user_name: 'name';
  user_cellphone: 'phone';
  bankcard_no: 'bankcard';
  identity_no: 'IDCard';
  [propName: string]: string;
}

const bindcardMap: IBindCardMap = {
  user_name: 'name',
  user_cellphone: 'phone',
  bankcard_no: 'bankcard',
  identity_no: 'IDCard',
};

// 有效期
function isExpire(value: string): string {
  const isExpireReg = /^\d{4}$|^\d{2}\/\d{2}$/g.test(value);
  const prevTwo = parseInt(value.substring(0, 2), 10);

  if (value !== '' && !isExpireReg) {
    return '有效期为4位数字';
  } else if (prevTwo === 0 || prevTwo > 12) {
    return '有效期前两位数字范围为01-12';
  }

  return '';
}

// 台胞证，长度=8
function isTaiBao(value: string): string {
  if (value !== '' && value.length < 8) {
    return '台胞证号应至少为8位';
  }
  return '';
}

export const validate = (type: string, value: string) => {
  switch (type) {
    case 'user_cellphone':
    case 'user_name':
    case 'bankcard_no':
    case 'identity_no':
      return validator.test(bindcardMap[type], value);
    case 'bankcard_expire':
      return isExpire(value);
    case 'taibao_no':
      return isTaiBao(value);
    default:
      return '';
  }
};

export const getAmountUnit = (amount: string) => {
  const notFloat = amount.split('.')[0];
  let amountUnit = '';
  if (notFloat.length === 4) {
    amountUnit = '千';
  }
  if (notFloat.length === 5) {
    amountUnit = '万';
  }
  if (notFloat.length === 6) {
    amountUnit = '十万';
  }
  if (notFloat.length === 7) {
    amountUnit = '百万';
  }
  if (notFloat.length === 8) {
    amountUnit = '千万';
  }
  if (notFloat.length === 9) {
    amountUnit = '亿';
  }
  if (notFloat.length === 10) {
    amountUnit = '十亿';
  }
  return amountUnit;
};
